export namespace Connection {
  export interface IConnectionLine {
    id: number;
    weight: number;
  }

  export interface IConnectionResponse {
    film_id: string;
    line_width: IConnectionLineType;
  }

  export enum IConnectionLineType {
    FEW = 'few',
    ONE = 'one',
    MORE = 'more',
    MANY = 'many',
  }
}
